import { SEO } from '../../../components/seo/SEO';
import { getBaseUrl } from '../../../lib/utils';
import { copy } from '../../../content/copy';

export default function TermsPage() {
  const baseUrl = getBaseUrl();

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '利用規約｜未来管制塔',
    description: '未来管制塔の利用規約。サービスご利用の際は本規約をご確認ください。',
    url: `${baseUrl}/legal/terms`,
    publisher: {
      '@type': 'Organization',
      name: '未来管制塔',
      url: baseUrl
    }
  };

  return (
    <>
      <SEO
        title="利用規約｜未来管制塔"
        description="未来管制塔の利用規約。サービスご利用の際は本規約をご確認ください。"
        canonical="/legal/terms"
        jsonLd={jsonLd}
      />
      <div className="min-h-screen bg-cosmic-bg py-12 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-cosmic-card border border-cosmic-border rounded-xl p-6 sm:p-10">
            <h1 className="text-3xl sm:text-4xl font-bold mb-8 text-cosmic-text-primary">
              {copy.legal.terms.title}
            </h1>
            <div className="prose prose-invert max-w-none">
              <div className="text-base sm:text-lg text-cosmic-text-secondary leading-relaxed whitespace-pre-line">
                {copy.legal.terms.content}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
